
import axios from 'axios'; // 引入axios
import { Toast } from 'antd-mobile';
import { getSearchParams } from './getSearchParms';

const request = axios.create({
  // 初始化配置axios
  baseURL: process.env.REACT_APP_BASE_URL, // baseUrl按照编译环境更改
  timeout: 15 * 1000, // 设置超时时间为15s
});

// 请求拦截
request.interceptors.request.use(
  (req) => {
    const token =
      typeof window !== 'undefined'
        ? getSearchParams('token', window.location.search)
        : null;
    req.headers!.Authorization = token; // 统一注入sign 到Authorization字段
    req.headers!.pathname = 'ADVISER_APP';
    return req; // 返回req
  },
  (err) => {
    Promise.reject(err); // 处理err
  }
);

// 响应拦截
request.interceptors.response.use(
  (res) => {
    // 检查业务错误码
    const { code, msg } = res.data || {};
    if (code !== undefined && code !== 200) {
      // 业务错误，显示提示并抛出错误
      const errorMsg = msg || '请求失败';
      Toast.show({ content: errorMsg });
      const error = new Error(errorMsg);
      (error as any).response = res; // 保留响应信息
      (error as any).code = code; // 保留业务错误码
      return Promise.reject(error);
    }
    return {
      ...res,
      headers: { 'x-auth-token': res.headers['x-auth-token'] },
    };
  },
  (err) => {
    // 网络错误，显示提示
    const errorMsg = err.response?.data?.msg || err.message || '网络请求失败';
    Toast.show({ content: errorMsg });
    return Promise.reject(err);
  }
);

export default request;
